module.exports = __webpack_public_path__ + "img/series-post.25ebac6b.jpeg";